<template>
    <div class="loading" :style="{'overflow':isShow ? 'hidden' : 'auto'}">
        <div class="content" :style="{'overflow':isShow ? 'hidden' : 'auto'}">
            <div class='text1'>智眸-智能风险预警平台</div>
            <div class='text2'>给你一双看管市场的眼睛</div>
            <a class="load-btn" @click="loadAPP">下载智眸</a>
        </div>
        <div v-show="isShow" class="modal" @click="isShow = false">
            <div class="modal-text">
                <div class="icon"></div>
                <span>点击这里打开浏览器查看</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            agentName:"",
            isAndroid:false,
            isIOS:false,
            href:"",
            isShow:false,
            IOSURL:" https://apps.apple.com/cn/app/%E6%99%BA%E7%9C%B8/id1587561119",
            AndroidURL:"https://zhimou.gildata.com/zhimouappshare/%E6%99%BA%E7%9C%B8_1.0.0_android_20211012105506_R_Andro.apk",
        }
    },
    created(){
        document.title = "智眸"
        this.agentName = window.navigator.userAgent.toLowerCase()
    },
    methods:{
        loadAPP(){
            let that = this
            that.checkPhone()
            if(that.isAndroid){//安卓
                if(that.agentName.match(/micromessenger/i) == 'micromessenger'){//微信浏览器
                    this.isShow = true
                }else{
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = that.AndroidURL
                    link.setAttribute('download','zhimou_android.apk')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }
            }else if(that.isIOS){//ios
                if(that.agentName.match(/micromessenger/i) == 'micromessenger'){//微信浏览器
                    this.isShow = true
                }else{
                    window.location.href=that.IOSURL
                }
            }
        },
        // 判断是安卓还是IOS
        checkPhone(){
            let that = this
            let agent = (navigator.userAgent || navigator.vendor || window.opener)
            if(agent !== null){
                let agentName = agent.toLowerCase()
                if(/android/i.test(agentName)){
                    that.isAndroid = true
                }else if(/iphone/i.test(agentName)){
                    that.isIOS = true
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.loading{
    position: relative;
    width:100vw;
    height:100vh;
    text-align: center;
    .content{
        box-sizing: border-box;
        background:url("./images/loading.png") no-repeat;
        background-size: cover;
        width:100%;
        min-height: 100%;
        padding-top:113%;
        padding-bottom: .4rem;
        .text1{
            color:#303133;
            line-height: .6rem;
            font-size:.48rem;
            font-weight: bold;
        }
        .text2{
            margin-top: .16rem;
            color:#909399;
            line-height: .4rem;
            font-size:.36rem;
            font-weight: 300;
        }
        .load-btn{
            display:block;
            margin:0.65rem auto 0;
            color:#fff;
            width:5rem;
            height: 1.04rem;
            line-height:1.04rem;
            font-size:.44rem;
            border-radius: .08rem;
            background-image: linear-gradient(to right, #3258DE , #25B1FF);
            text-align: center;
            text-decoration: none;
        }
    }
    .modal{
        position: fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        background: rgba(0,0,0,.5);
        overflow: hidden;
        z-index: 100;
        .modal-text{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            padding-top:.2rem;
            color:#fff;
            font-size:.28rem;
            padding-right:.52rem;
            text-align: right;
            .icon{
                margin-bottom: .1rem;
                width:1.38rem;
                height:1.32rem; 
                background:url("./images/guide.png") no-repeat;
                background-size: cover;
            }
        }
    }
}

</style>
